export default __webpack_public_path__ + "static/micaballoonv3-ea394f3abe65f85ad2075f9eecd78e1d.png";